import { API } from '../http';

async function signIn(user = { username: '', password: '' }) {
  return await API.post('/login', user);
}

const authServices = {
  signIn,
};

export default authServices;
